import styled from 'styled-components';
import theme from 'styled-theming';

/* stylelint-disable */
import { Modal as ShellModal } from '../../../UI/Modal';

const FieldMappingTableDangerBgColor = theme('name', {
  light: 'rgba(217, 54, 56, 0.7)',
  dark: 'rgba(217, 54, 56, 0.5)',
});

const FieldMappingTableWarningBgColor = theme('name', {
  light: 'rgba(251, 207, 9, 0.4)',
  dark: 'rgba(251, 207, 9, 0.8)',
});

const FieldMappingTableWarningTextColor = theme('name', {
  light: 'rgb(2, 1, 1)',
  dark: '#fff',
});

export const FieldNominationWrapper = styled.div`
  position: relative;
  height: calc(100vh - 150px);

  .refresh-btn {
    border-radius: 50%;
  }

  .clone-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .delete-action-btn {
    &:disabled {
      background-color: transparent;

      svg path {
        fill: rgb(196 191 191);
      }
    }
  }

  .clone-disable-info {
    font-size: 14px;
    padding: 10px;
  }

  .actions-cell {
    padding: 0;
    text-align: center;
    width: 100px;
  }

  .ad-hoc-btn {
    cursor: pointer;
    background-color: rgb(0, 151, 169);
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    font-style: normal;
    position: relative;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 0 12px;
    margin: 0;
    border: 1px solid transparent;
    border-radius: 2px;
    transition:
      box-shadow 0.3 scubic-bezier(0.35, 0, 0.25, 1),
      background-color 0.3s,
      border 0.3s;
    min-width: 64px;
    min-height: 32px;
    color: white;
    &:hover {
      background-color: rgba(0, 150, 187, 0.78);
    }

    & svg circle:nth-of-type(2) {
      stroke: white;
    }
  }

  .card {
    padding-bottom: unset;
  }

  .heading {
    display: flex;
    .shell-text-heading {
      margin-right: 5px;
    }
  }

  .unmapped_table_container {
    .shell-table-container {
      max-height: 30vh;
      position: relative;
      overflow-y: auto;
    }
  }

  .mail-counts {
    display: flex;
    align-items: center;
    margin-left: 17px;
    font-weight: 500;
    position: relative;
    font-size: 15px;
    .counts {
      background: red;
      color: white;
      padding: 5px;
      height: 18px;
      min-width: 18px;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: -10px;
      top: -5px;
      font-size: 10px;
      font-weight: 700;
    }
  }

  .last-refreshed {
    color: rgb(0, 133, 87);
    font-size: 15px;
    align-self: center;
    font-weight: 500;
  }

  .filter-container {
    margin: 30px 0 20px 0;
    justify-content: space-between;
    .filters {
      display: flex;
      gap: 20px;
    }
    .select-filter {
      width: 135px;
      .shell-select-container-selection-item {
        font-weight: 600;
      }
    }
    .date-range {
      display: flex;
      gap: 20px;
      .shell-text-input {
        width: 270px;
      }
    }
    span {
      font-weight: 500;
      min-width: fit-content;
      font-size: 14px;
    }

    .energy {
      display: flex;
      span {
        align-self: center;
        margin-right: 10px;
      }
    }
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    .shell-toggle span {
      margin: 0 10px 0 5px;
    }
  }

  .show-success-status,
  .show-latest-status {
    display: flex;
  }

  .close-mapping {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  .grid-actions {
    display: flex;
    button:last-child {
      margin-left: 5px;
    }
  }

  .compare-energy {
    background-color: transparent;
    &.check {
      svg > path {
        fill: green;
      }
    }
    &.cross {
      svg > path {
        fill: red;
      }
    }
  }

  .aligne-status__wrapper {
    display: flex;
    gap: 5px;

    .undo-acknowledge {
      height: 24px;
      width: 24px;
      min-height: 24px;
    }
  }

  .aligne-status {
    width: fit-content;
    min-width: 80px;
    min-height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    border-radius: 16px;
    color: rgba(255, 255, 255, 1);
    font-weight: 500;
    font-size: 13px;
    &.not_requested {
      background-color: white;
      border: 1px solid rgba(0, 0, 0, 0.15);
      color: rgba(64, 64, 64, 1);
    }
    &.submitted {
      background-color: rgba(251, 207, 9, 1);
      color: rgba(64, 64, 64, 1);
    }
    &.success,
    &.acknowledged {
      background-color: rgba(28, 132, 80, 1);
    }
    &.failure {
      background-color: rgba(217, 54, 56, 1);
    }
    &.in-queue {
      background-color: rgb(75, 103, 246);
    }
  }

  .upload-progress {
    display: flex;
    justify-content: center;
    .shell-alert {
      width: fit-content;
      div:has(.refresh-field_noms) {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .refresh-field_noms {
        text-decoration: underline;
      }
    }
  }

  .shell-table-cell:has(.table-row_disabled) {
    opacity: 0.7;
  }

  .shell-table-cell:has(.da-variance-breach_alert) {
    background-color: rgba(251, 207, 9, 1);
    color: black;
  }

  .shell-table-cell:has(.wd-variance-breach_alert) {
    background-color: rgba(217, 54, 56, 1);
    color: white;
    .compare-energy {
      &.cross {
        svg > path {
          fill: white;
        }
      }
    }
  }

  .shell-table-row:hover > .shell-table-cell:has(.da-variance-breach_alert) {
    background-color: rgba(251, 207, 9, 1);
    color: black;
  }

  .shell-table-row:hover > .shell-table-cell:has(.wd-variance-breach_alert) {
    background-color: rgba(217, 54, 56, 1);
    color: white;
    .compare-energy {
      &.cross {
        svg > path {
          fill: white;
        }
      }
    }
  }

  .field-terminal-mapping-table tbody .row-danger td:not(:last-child) {
    background-color: ${FieldMappingTableDangerBgColor};
    color: #fff;
  }

  .field-terminal-mapping-table tbody .row-warning td:not(:last-child) {
    background-color: ${FieldMappingTableWarningBgColor};
    color: ${FieldMappingTableWarningTextColor};
  }
`;

export const TerminalMappingWrapper = styled.div`
  position: relative;
  height: calc(100vh - 150px);

  .field-terminal-mapping-table {
    width: 100%;
  }

  .table-container {
    max-width: calc(100vw - 50px);
    overflow: auto;
  }

  .header-with-close {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .refresh-btn {
    border-radius: 50%;
  }

  .clone-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .delete-action-btn {
    &:disabled {
      background-color: transparent;

      svg path {
        fill: rgb(196 191 191);
      }
    }
  }

  .clone-disable-info {
    font-size: 14px;
    padding: 10px;
  }

  .ad-hoc-btn {
    cursor: pointer;
    background-color: rgb(0, 151, 169);
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0;
    font-style: normal;
    position: relative;
    display: inline-flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 0 12px;
    margin: 0;
    border: 1px solid transparent;
    border-radius: 2px;
    transition:
      box-shadow 0.3 scubic-bezier(0.35, 0, 0.25, 1),
      background-color 0.3s,
      border 0.3s;
    min-width: 64px;
    min-height: 32px;
    color: white;
    &:hover {
      background-color: rgba(0, 150, 187, 0.78);
    }

    & svg circle:nth-of-type(2) {
      stroke: white;
    }
  }

  .card {
    padding-bottom: unset;
  }

  .heading {
    display: flex;
    .shell-text-heading {
      margin-right: 5px;
    }
  }

  .unmapped_table_container {
    .shell-table-container {
      max-height: 40vh;
      position: relative;
      overflow-y: auto;
    }
  }

  .mail-counts {
    display: flex;
    align-items: center;
    margin-left: 17px;
    font-weight: 500;
    position: relative;
    font-size: 15px;
    .counts {
      background: red;
      color: white;
      padding: 5px;
      height: 18px;
      min-width: 18px;
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: -10px;
      top: -5px;
      font-size: 10px;
      font-weight: 700;
    }
  }

  .last-refreshed {
    color: rgb(0, 133, 87);
    font-size: 15px;
    align-self: center;
    font-weight: 500;
  }

  .filter-container {
    margin: 30px 0 20px 0;
    justify-content: space-between;
    .filters {
      display: flex;
      gap: 20px;
    }
    .select-filter {
      width: 135px;
      .shell-select-container-selection-item {
        font-weight: 600;
      }
    }
    .date-range {
      display: flex;
      gap: 20px;
      .shell-text-input {
        width: 270px;
      }
    }
    span {
      font-weight: 500;
      min-width: fit-content;
      font-size: 14px;
    }

    .energy {
      display: flex;
      span {
        align-self: center;
        margin-right: 10px;
      }
    }
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    .shell-toggle span {
      margin: 0 10px 0 5px;
    }
  }

  .show-success-status,
  .show-latest-status {
    display: flex;
  }

  .grid-actions {
    display: flex;
    button:last-child {
      margin-left: 5px;
    }
  }

  .compare-energy {
    background-color: transparent;
    &.check {
      svg > path {
        fill: green;
      }
    }
    &.cross {
      svg > path {
        fill: red;
      }
    }
  }

  .aligne-status__wrapper {
    display: flex;
    gap: 5px;

    .undo-acknowledge {
      height: 24px;
      width: 24px;
      min-height: 24px;
    }
  }

  .aligne-status {
    width: fit-content;
    min-width: 80px;
    min-height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    border-radius: 16px;
    color: rgba(255, 255, 255, 1);
    font-weight: 500;
    font-size: 13px;
    &.not_requested {
      background-color: white;
      border: 1px solid rgba(0, 0, 0, 0.15);
      color: rgba(64, 64, 64, 1);
    }
    &.submitted {
      background-color: rgba(251, 207, 9, 1);
      color: rgba(64, 64, 64, 1);
    }
    &.success,
    &.acknowledged {
      background-color: rgba(28, 132, 80, 1);
    }
    &.failure {
      background-color: rgba(217, 54, 56, 1);
    }
    &.in-queue {
      background-color: rgb(75, 103, 246);
    }
  }

  .upload-progress {
    display: flex;
    justify-content: center;
    .shell-alert {
      width: fit-content;
      div:has(.refresh-field_noms) {
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .refresh-field_noms {
        text-decoration: underline;
      }
    }
  }

  .shell-table-cell:has(.table-row_disabled) {
    opacity: 0.7;
  }

  .shell-table-cell:has(.da-variance-breach_alert) {
    background-color: rgba(251, 207, 9, 1);
    color: black;
  }

  .shell-table-cell:has(.wd-variance-breach_alert) {
    background-color: rgba(217, 54, 56, 1);
    color: white;
    .compare-energy {
      &.cross {
        svg > path {
          fill: white;
        }
      }
    }
  }

  .shell-table-row:hover > .shell-table-cell:has(.da-variance-breach_alert) {
    background-color: rgba(251, 207, 9, 1);
    color: black;
  }

  .shell-table-row:hover > .shell-table-cell:has(.wd-variance-breach_alert) {
    background-color: rgba(217, 54, 56, 1);
    color: white;
    .compare-energy {
      &.cross {
        svg > path {
          fill: white;
        }
      }
    }
  }

  .field-terminal-mapping-table tbody .row-danger td:not(:last-child) {
    background-color: ${FieldMappingTableDangerBgColor};
    color: #fff;
  }

  .field-terminal-mapping-table tbody .row-warning td:not(:last-child) {
    background-color: ${FieldMappingTableWarningBgColor};
    color: ${FieldMappingTableWarningTextColor};
  }
`;

export const ColumnTitleContainer = styled.div`
  display: flex;
  .sorting-wrapper {
    display: flex;
    .shell-table-column-sorter {
      margin: unset;
      svg:first-child path {
        fill: ${(prop) => prop.color};
      }
    }
    .shell-table-column-title {
      display: flex;
      align-items: center;
    }
  }

  .pointer {
    cursor: pointer;
  }
`;

export const TableLoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgb(0, 0, 0, 0.05);
  z-index: 1000;

  .loader-wrapper {
    background-color: #fff;
    padding: 15px;
    border-radius: 4px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 15px;
  button:last-child {
    margin-left: 10px;
  }
  &.upload-aligne {
    .button-wrapper {
      display: flex;
    }
  }
  &.upload-aligne__confirm {
    justify-content: space-between;
    .message {
      display: flex;
      align-items: center;
      margin-right: 10px;
      font-weight: 500;
      color: rgba(217, 54, 56, 1);
    }
  }

  &.report-modal-footer {
    justify-content: space-between;
  }
`;

export const AuditDetailWrapper = styled.div`
  min-height: 250px;
  max-height: 60vh;
  overflow-y: auto;
  .title {
    font-weight: 600;
    font-size: 14px;
  }
  .logs-info {
    width: 25px;
    height: 25px;
    min-height: 25px;
    margin-left: 5px;
  }
  th,
  td {
    padding: 3px 14px 3px 0 !important;
    background-color: unset !important;
  }
  tr td:first-child,
  tr td:last-child {
    display: flex;
  }
  .shell-table tr:hover td {
    background-color: unset !important;
  }

  pre {
    background: rgba(0, 0, 0, 0.1);
    color: unset;
    padding: 5px;
    border-radius: 3px;
  }
  .__json-pretty__ .__json-value__ {
    color: rgb(51, 204, 51);
  }
  .__json-pretty__ .__json-key__ {
    color: #eb0f5f;
  }
`;

export const Modal = styled(ShellModal)`
  .button-style {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 10px;
  }

  .shell-date-picker-dropdown-range {
    inset: 188px auto auto -84px !important;
    position: fixed;
  }
  .shell-select-dropdown {
    position: fixed;
  }
  .helper-text {
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
`;

export const DeleteTooltip = styled.div`
  padding: 10px;

  .actions {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }
`;

export const ModalWrpapper = styled.div`
  .highlight-label {
    color: #f5a623;
  }
`;

export const DANomsAuditWrapper = styled.div`
  position: relative;
  height: calc(100vh - 150px);

  .header-with-close {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .filter-container {
    margin: 30px 0 20px 0;
    justify-content: space-between;
    .filters {
      display: flex;
      gap: 20px;
    }
    .select-filter {
      width: 135px;
      .shell-select-container-selection-item {
        font-weight: 600;
      }
    }
    .date-range {
      display: flex;
      gap: 20px;
      .shell-text-input {
        width: 270px;
      }
    }
    span {
      font-weight: 500;
      min-width: fit-content;
      font-size: 14px;
    }

    .energy {
      display: flex;
      span {
        align-self: center;
        margin-right: 10px;
      }
    }
  }

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    .shell-toggle span {
      margin: 0 10px 0 5px;
    }
  }

  .shell-table-cell:has(.table-row_disabled) {
    opacity: 0.7;
  }

  .payload-section {
    margin-top: 20px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    padding: 16px;
    background-color: #f9f9f9;

    .payload-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
      font-weight: 600;
      .payload-data-header {
        color: rgb(41, 41, 41);
      }
    }

    .payload-info {
      background-color: #ffc600 !important;
      color: black;
    }

    .payload-info svg {
      color: #ffc600;
      fill: currentColor;
    }

    .payload-content {
      max-height: 300px;
      overflow: auto;
      background-color: #2d3748;
      border-radius: 4px;
      padding: 12px;
    }
  }

  .note-with-payload {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .status-pending,
  .status-sent,
  .status-success,
  .status-failure {
    width: fit-content;
    min-width: 80px;
    min-height: 24px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    padding: 0 8px;
    border-radius: 16px;
    color: white;
    font-weight: 500;
    font-size: 13px;
  }

  .status-pending {
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: rgba(64, 64, 64, 1);
  }

  .status-sent {
    background-color: rgb(0, 133, 87);
  }

  .status-success {
    background-color: rgb(0, 133, 87);
  }

  .status-failure {
    background-color: rgb(220, 20, 60);
  }
  .table-wrapper {
    div {
      width: 100%;
    }
  }
`;
